import Aura from '@primeuix/themes/aura';
import { definePreset } from "@primeuix/themes";


export const MyPreset = definePreset(Aura, {
    semantic: {
         primary: 'noir'
    }
});
